import { useMemo } from 'react';

import {
  EditorDataProvider,
  createEditorDataExtension,
} from '@spotify/confidence-editor-react';
import { useAvailableMetrics } from '@spotify/plugin-confidence-workflows-module-stats-data';

import { useTreatmentsData } from '../hooks';
import { confidenceWorkflowsModuleAbTestPlugin } from '../plugin';

const WorkflowEditorDataProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const availableMetrics = useAvailableMetrics();
  const { treatments } = useTreatmentsData();

  const value = useMemo(
    () => ({ availableMetrics, treatments }),
    [availableMetrics, treatments],
  );

  return <EditorDataProvider value={value}>{children}</EditorDataProvider>;
};

export const WorkflowEditorDataExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(
    createEditorDataExtension({
      id: 'workflow-editor-data',
      DataProvider: WorkflowEditorDataProvider,
    }),
  );
